export type Result = {
  prevRank: number;
  winRank: number;
  loseRank: number;
};

export default function calculateRank(myRank: number, hisRank: number): Result {
  const prevRank = myRank;
  let winRank = prevRank;
  let loseRank = prevRank;

  const delta = myRank - hisRank;

  if (delta === 1) winRank = hisRank;
  if (delta === -1) loseRank = hisRank;
  if (delta > 1) winRank = Math.floor((myRank + hisRank) / 2);

  return { prevRank, winRank, loseRank };
}
